import { render, staticRenderFns } from "./UpdateClassesJob.vue?vue&type=template&id=ebf4cc1a"
import script from "./UpdateClassesJob.vue?vue&type=script&lang=js"
export * from "./UpdateClassesJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports